import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

export const orderSyncStatusKey = ["order-sync-status"] as const;

/**
 * GET /v1/orders/sync-status — the newest marketplace_raw_orders row's
 * fetched_at. Every path that brings order data in (manual Sync, the
 * scheduler's order poll, marketplace webhooks) writes one of those rows, so
 * this reflects "when did Atlas last learn anything from a marketplace"
 * regardless of which path did it.
 */
export function useOrderSyncStatus() {
  return useQuery({
    queryKey: orderSyncStatusKey,
    queryFn: async (): Promise<string | null> => {
      const { data, error } = await apiClient.GET("/v1/orders/sync-status");
      if (error) throw error;
      return data.last_synced_at;
    },
  });
}
